import * as moment from 'moment';

import RoutingActions from '../../../actions/RoutingActions';
import GuestListActions from '../../../actions/GuestListActions';
import PopupActions from '../../../actions/PopupActions';
import NotificationActions from '../../../actions/NotificationActions';
import GuestListStore from '../../../stores/GuestListStore';
import UserStore from '../../../stores/UserStore';
import UserActions from '../../../actions/UserActions';

class CheckInToPos extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loading : false
        };

        this.checkGuestInToPos = this.checkGuestInToPos.bind(this);
        this.validate = this.validate.bind(this);
    }

    validate() {
        var selectedLocation = UserStore.getState().selectedLocation;
        var attestationExpirationDate = moment(this.props.guest.AttestationExpirationDate);

        if (!!selectedLocation.RequireDoctorForCheckIn) {
            if(!(parseInt(this.props.guest.doctor) > 0)) {
                NotificationActions.addNotification({
                    type : 'alert',
                    body : 'Patient does not have a doctor on record.'
                });
                return false;
            }
        }

        if (!this.props.guest.CustomerTypeId) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Patient does not have a customer type on record.'
            });
            return false;
        }

        if (this.props.guest.CustomerTypeId === 1) {
            if (this.props.guest.Attestation.toLowerCase() === 'no' && selectedLocation.Attestation) {
                NotificationActions.error('Patient Has not completed the Attestation Document. You cannot Proceed.')
                return false;
            }

            if ((moment().isAfter(attestationExpirationDate, 'day') || moment().isSame(attestationExpirationDate, 'day')) && selectedLocation.Attestation) {
                NotificationActions.error('Patient Attestation Document has expired. You cannot Proceed.')
                return;
            }
        }

        if (!UserStore.getState().selectedRegister) {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Please select a register first'
            });
            return false;
        }

        if (selectedLocation.CanUseMassDPHIntegration && !UserStore.getState().validDPHCredentials  && guest.PatientType !== 'Recreational' && selectedLocation.RequireValidAllotmentCredentials) {
            NotificationActions.error('Your DPH Credentials are invalid! Go to settings and update to continue.', true);
            return false;
        }

        if (this.props.guest.status != 'Active') {
            NotificationActions.addNotification({
                type : 'alert',
                body : 'Patient is ' + this.props.guest.status + '.'
            });
            return (UserStore.getState().selectedLocation.BlockBannedPatientCheckin && this.props.guest.status == 'Banned') ? false : true;
        }

        return true;
    }

    checkGuestInToPos() {
        const selectedLocation = UserStore.getState().selectedLocation;
        const guest = this.props.guest;

        if (this.state.loading || !this.validate()) {
            return;
        }

        let expirationDateError = false;

        if (selectedLocation.RequireValidDL
            && UserActions.isDriversLicenseExpired(this.props.guest)) {
            
            expirationDateError = true;
            NotificationActions.error('Patient\'s Driver\'s License has expired.');
        }

        if (selectedLocation.MMJIdExpirationDateCheck && guest.IsMedical
            && UserActions.isMMJLicenseExpired(this.props.guest)) {

            expirationDateError = true;
            NotificationActions.error('Patient\'s MMJ License has expired.');
        }

        if (selectedLocation.MMJIdExpirationDateCheck && guest.IsMedical &&
            selectedLocation.NotifyCard30DayExpiration && UserActions.isMMJLicenseAboutExpire(this.props.guest)) {
            const days = UserActions.mmjLicenseDaysFromExpiration(this.props.guest);
            NotificationActions.warn(`Patient\'s MMJ License is about to expire in ${days} days.`);
        }

        const minorAge = UserActions.getMinorAge(selectedLocation, this.props.guest.IsMedical)
        if (selectedLocation.BlockMinorsFromCheckInFF && UserActions.checkMinorStatus(this.props.guest, minorAge)) {

            NotificationActions.error(`Patient is under the age of ${minorAge}. You cannot proceed`);
            return;
        }

        if (expirationDateError) {
            return;
        }

        this.setState({ loading : true });

        //Does this logic belong to the action?
        GuestListActions.checkGuestIn(this.props.guest, true)
            .then((x) => {
                var success = x.Result === true;

                if (success) {
                    this.setState({ loading : false });
                    var guest = this.props.guest;
                    guest.ShipmentId = x.Data[0].ShipmentId;
                    RoutingActions.updateRoute('pos/'+guest.Guest_id);
                    GuestListActions.selectGuestForPos(guest); //Probably skip this?  seems like it should happen in the server side call?
                    PopupActions.close(); //TODO: Y THO
                }
            })
            .catch(() => {
                this.setState({ loading : false });
            });
    }

    render() {
        var valid = UserStore.getState().selectedRegister && !(UserStore.getState().selectedLocation.BlockBannedPatientCheckin && this.props.guest.status == 'Banned');

        return (
            <button
                className={'btn-green '+(!valid ? 'btn-green__disabled' : '')}
                onClick={this.checkGuestInToPos}
                disabled={false}
            >
                { this.props.loading ? 'Loading' : 'CHECKIN TO POS' }
            </button>
        );
    }
}

export default CheckInToPos;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/sidebar/CheckInToPos.react.jsx